<div class="search-map">
  <app-map-list [path]="path" />
  <app-world-map [id]="id" [path]="path" />
</div>
